import { Button } from '../../../../core/components/atoms/Button';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Typography } from '../../../../core/components/molecules/Typography';
import PortuguesPNG from '../../../../assets/images/flashcards/disciplines/portugues.png';

const DisciplinesFlashCard = ({
  title,
  qtd,
  bgImage,
  gradient,
  onClick,
}: {
  uuid?: string;
  title: string;
  qtd: number;
  bgImage: string;
  gradient: string;
  onClick: () => void;
}) => {
  // const adjustColor = (hex: string, percent: number): string => {
  //   const num = parseInt(hex.replace('#', ''), 16);
  //   let r = (num >> 16) + percent;
  //   let g = ((num >> 8) & 0x00ff) + percent;
  //   let b = (num & 0x0000ff) + percent;

  //   r = Math.min(255, Math.max(0, r));
  //   g = Math.min(255, Math.max(0, g));
  //   b = Math.min(255, Math.max(0, b));

  //   return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0').toUpperCase()}`;
  // };

  // const generateGradient = (hex: string) => {
  //   const end = hex.toUpperCase();
  //   const start = adjustColor(end, 40); // Clareia ~15%
  //   return { start, end };
  // };

  // const generateGradientCSS = (hex: string): string => {
  //   const { start, end } = generateGradient(hex);
  //   return `radial-gradient(80% 55.46% at 15.42% 2.3%, ${start} 0%, ${end} 100%)`;
  // };

  // const gradient = `radial-gradient(80% 55.46% at 15.42% 2.3%, #D4EFB8 0%, ${color} 100%)`;
  // const gradient = generateGradientCSS(color || '#6B59A6');

  return (
    <div
      className='flex h-[174px] w-[125px] cursor-pointer flex-col items-center justify-center rounded-[20px]'
      style={{
        background: gradient,
      }}
      onClick={onClick}
    >
      <div className='mx-8'>
        <img
          src={bgImage || PortuguesPNG}
          alt='Imagem de Login'
          className='h-full w-full object-contain'
        />
      </div>
      <div className='mt-2 flex flex-col items-center justify-center'>
        <Typography className='text-center text-h5 font-bold !text-[#FFF]'>
          {title}
        </Typography>
        <div className='mt-2 flex items-center gap-2'>
          <div className=''>
            <Icon
              Icon='insert_drive_file'
              type='material'
              className='h-[10px] w-[10px] text-xs text-card-color-default'
            />
          </div>
          <Typography className='text-xs text-card-color-default'>
            {qtd || 0} <i>Flashcards</i>
          </Typography>
        </div>
      </div>
      <div className='flex items-center justify-center'>
        <Button
          size='small'
          variant='text'
          className='mt-1 text-card-color-default'
          onClick={onClick}
        >
          <Icon
            Icon='login'
            type='material'
            className='h-[10px] w-[10px] text-xs'
          />
          <Typography className='text-xs font-bold text-card-color-default'>
            Acessar
          </Typography>
        </Button>
      </div>
    </div>
  );
};
export default DisciplinesFlashCard;
